// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__jmApd","overflowing":"ReadFullNote_overflowing__3OQXV"};